import React, { useEffect, useState } from 'react'
import { Card, CardFooter, CardHeader, Container, Row, Table } from 'reactstrap';
import ClientBalanceModel from "models/clientbalance"
import Loader from "components/loader/Loader";

const Clientbalance = () => {
    const[data,setData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const ClientBalance = async()=>{
      setIsLoading(true);
        ClientBalanceModel.get()
        .then((responce)=>{
            setData(responce);
            setIsLoading(false);
        })
        .catch((error)=>{
            console.log("error",error)
        })
    }
    useEffect(()=>{
        ClientBalance();
    },[])
  return (
    <div className="pt-7 px-4">
    <Row>
    <div className="col">
      <Card className="shadow">
        <CardHeader className="border-0 d-flex justify-content-between ">
          <h3 className="mb-0">Client Balance</h3>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  {/* <th scope="col">CLASS ID</th> */}
                  <th scope="col"> Name</th>
                 
                  <th scope="col">Total paid Amount</th>
                  <th scope="col">Balance Amount</th>
                 
                  {/*<th scope="col">Action</th>*/}
                </tr>
              </thead>

              <tbody>
                    {isLoading ? (
                                 <tr>
                                   <td
                                     colSpan={12}
                                     className="text-center align-middle w-full"
                                   >
                                     Please wait...
                                     <Loader />
                                   </td>
                                 </tr>
                               ) : data?.data?.data?.length > 0 ? 
                               (
                  data?.data?.data?.map((item, index) => {
           
                    return (
                      <tr key={index} style={{ cursor: "pointer" }}>
                        <td>{index + 1}</td>

                        <td>
                        {`${item?.auth_user?.first_name} ${" "} ${item?.auth_user?.last_name }`}
                        </td>
                       
                        <td>{item?.price_parent || "-"}</td>
                        <td>{item?.price_parent - item?.paid_amount || "-"}</td>

                        
                     
                      </tr>
                    );
                  })
                ) : 
                (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ textAlign: "center", padding: "1rem" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
          </div>
          </Row>
    </div>
  )
}

export default Clientbalance
